// src/Simple3DComponent.js
import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { useMediaQuery } from 'react-responsive';

export default function Simple3DComponent() {
  // Responsive layout based on screen size
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });

  function Cube() {
    return (
      <mesh>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color="orange" />
      </mesh>
    );
  }

  return (
    <div style={containerStyle(isTabletOrMobile)}>
      <Canvas style={{ height: isTabletOrMobile ? '300px' : '600px', flex: 1 }}>
        <ambientLight intensity={0.3} />
        <directionalLight position={[10, 10, 5]} intensity={1} />
        <Cube />
        <OrbitControls enableZoom={!isTabletOrMobile} />
      </Canvas>
      <div style={infoPanelStyle}>
        <h2>Simple 3D Object</h2>
        <p>
          This is a 3D cube model rendered with Three.js and React Three Fiber. You can replace this
          cube with a GLTF model when ready.
        </p>
        <ul>
          <li>Color: Orange</li>
          <li>Shape: Cube</li>
          <li>Size: 1x1x1</li>
        </ul>
      </div>
    </div>
  );
}

const containerStyle = (isTabletOrMobile) => ({
  display: 'flex',
  flexDirection: isTabletOrMobile ? 'column' : 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
});

const infoPanelStyle = {
  maxWidth: '400px',
  textAlign: 'left',
  padding: '10px',
};